import useSWR from "swr"

import Container from "lib/components/Container"
import Text from "lib/components/Text"
import { NextSeo } from "next-seo"
import Image from "lib/components/Image"
import { ErrorContext } from "context/ErrorContext"
import { useContext, useEffect } from "react"
import { toast } from "react-toastify"
import { captureException } from "@sentry/react"
import { LanguageContext } from "context/LanguageContext"
import { useRouter } from "next/router"
import url from "url"
import fetcher from "lib/fetcher"

function TrustedBy() {
  const { data, error } = useSWR("/api/client/all_list", fetcher)
  const { useTranslation: t, language } = useContext(LanguageContext)

  const router = useRouter()
  const { pathname } = url.parse(router.asPath)
  const heroText = t("solve_needs_industries")
  const [before, target, after] = heroText.split(language === "ID" ? /(Memenuhi)/ : /(Solve)/)

  if (error) {
    const errorMessage =
      error.message || error.response?.data || "Unknown error occurred"
    toast.error(`Oops: ${errorMessage}`)
    captureException(errorMessage)
    return <div />
  }

  return (
    <div>
      <NextSeo 
        title={t("title_seo_trusted_by")} 
        description={t("solve_needs_industries")}
        canonical={`${process.env.NEXT_PUBLIC_URL}${pathname}`}/>
      <div className="relative">
        <Container>
          <div className="pt-4 sm:pt-20">
          <Text color="primary" alignText="center" type="medium-title" customClass="py-[9px] text-xl font-medium">
            {before}
            <span style={{ color: "#FFBE0B" }}>{target}</span>
            {after}
          </Text>
            <Text alignText="center" customClass="text-xs xl:text-base">{t("several_well_known_companies")}</Text>
            <div className="relative grid grid-cols-3 sm:grid-cols-6 gap-4 items-center my-4 sm:my-8">
              {data?.company_company?.map((client) => (
                <div key={client?.name} className="w-full h-full p-2 lg:w-[10.813rem] lg:h-[11rem] content-center rounded-xl border-[1px] border-[#D1D5DB]">
                  <Image
                    alt={client?.name}
                    width={300}
                    height={150}
                    src={
                      client?.company_thumbnail_url ||
                      "https://res.cloudinary.com/https-www-pasartrainer-com/image/upload/v1669214024/client/no-image.png"
                    }
                    objectFit="contain"
                    objectPosition="center"
                  />
                </div>
              ))}
            </div>
          </div>
        </Container>
      </div>
    </div>
  )
}

export default TrustedBy
